import type { ResolveInviteResponseDto } from "@service/network/supplier/dto/resolve-invite-response.dto";
import { useQuery, UseQueryResult } from "@tanstack/react-query";

import { retryUnlessClientError } from "../../../../../shared/api/api-retry";
import { supplierQueryKeys } from "../../shared/query-keys";
import { resolveAsAuthenticated } from "./supplier-registration.api";

export const useAuthenticatedResolve = (
  connectionRequestId: string,
  enabled: boolean
): UseQueryResult<ResolveInviteResponseDto> =>
  useQuery({
    queryKey: supplierQueryKeys.authenticatedResolve(connectionRequestId),
    queryFn: () => resolveAsAuthenticated(connectionRequestId),
    enabled: Boolean(connectionRequestId) && enabled,
    retry: retryUnlessClientError(),
  });
